var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.1875 7.125 0 16 0C24.8125 0 32 7.1875 32 16C32 24.875 24.8125 32 16 32C7.125 32 0 24.875 0 16ZM23.1875 13.25C23.875 12.5625 23.875 11.5 23.1875 10.8125C22.5 10.125 21.4375 10.125 20.75 10.8125L14 17.5625L11.1875 14.8125C10.5 14.125 9.4375 14.125 8.75 14.8125C8.0625 15.5 8.0625 16.5625 8.75 17.25L12.75 21.25C13.4375 21.9375 14.5 21.9375 15.1875 21.25L23.1875 13.25Z",
    fill: "#18315A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.a8023d2667582d1161db15aacc82fd61.svg";
export { ForwardRef as ReactComponent };